import { render, staticRenderFns } from "./LegendButton.vue?vue&type=template&id=1ad87362&"
import script from "./LegendButton.vue?vue&type=script&lang=js&"
export * from "./LegendButton.vue?vue&type=script&lang=js&"
import style0 from "./LegendButton.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/bsjung/work/xtc/trading-chart-js/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ad87362')) {
      api.createRecord('1ad87362', component.options)
    } else {
      api.reload('1ad87362', component.options)
    }
    module.hot.accept("./LegendButton.vue?vue&type=template&id=1ad87362&", function () {
      api.rerender('1ad87362', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/LegendButton.vue"
export default component.exports